var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{attrs:{"active-text":"实时刷新"},on:{"change":_vm.realtimeChange},model:{value:(_vm.realtime),callback:function ($$v) {_vm.realtime=$$v},expression:"realtime"}})}
var staticRenderFns = []

export { render, staticRenderFns }